// extracted by mini-css-extract-plugin
module.exports = {"templateContent":"EmailTemplates_templateContent__2PK4p"};